document.addEventListener('DOMContentLoaded', function () {
  const pre = document.getElementById('venue-preloader');
  if (!pre) return;

  document.body.classList.remove('js-theme-loading','theme-loading','loading','preloading');
  document.documentElement.classList.remove('js-theme-loading','theme-loading','loading','preloading');

  const logo   = document.getElementById('preloader-logo-img');
  const rectEl = document.getElementById('preloader-rect');
  const imgWrap= document.getElementById('preloader-image-container');
  const imgEl  = document.getElementById('preloader-image');
  const t1     = document.getElementById('text-line-1');
  const t2     = document.getElementById('text-line-2');

  const qp = new URLSearchParams(location.search);
  const dbgAttr = String(pre.dataset.debug || '').toLowerCase();
  let debug = dbgAttr === 'true' || dbgAttr === '1' || dbgAttr === 'on' || qp.get('preloader') === 'debug';

  let mode = (pre.dataset.mode || 'fade_sequence').toLowerCase();
  const modeParam = (qp.get('mode') || '').toLowerCase();
  if (['fade_sequence','image_only','cover'].includes(modeParam)) mode = modeParam;

  const frequency = (pre.dataset.frequency || 'smart').toLowerCase(); // always | once | smart
  const storageKey = pre.dataset.storageKey || 'venue_preloader_seen_v1';

  if (qp.get('preloader') === 'clear' || qp.get('preloader') === 'reset') {
    try { localStorage.removeItem(storageKey); } catch(e){}
  }
  const forceShow = qp.get('preloader') === 'force';

  let seen = false;
  try { seen = localStorage.getItem(storageKey) === '1'; } catch(e){}

  const getNavType = () => {
    try {
      const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type;
      const t = performance.navigation && performance.navigation.type;
      return ({0:'navigate',1:'reload',2:'back_forward'})[t] || 'navigate';
    } catch { return 'navigate'; }
  };
  const navType = getNavType();
  const isReload = navType === 'reload';
  const isBackForward = navType === 'back_forward';
  let sameOriginReferrer = false;
  try { sameOriginReferrer = !!document.referrer && new URL(document.referrer).host === location.host; } catch(e){}
  const isExternalEntrance = !sameOriginReferrer;

  let shouldShow = true;
  if (!debug && !forceShow) {
    if (frequency === 'once') {
      shouldShow = !seen;
      if (shouldShow) { try { localStorage.setItem(storageKey,'1'); } catch(e){} }
    } else if (frequency === 'smart') {
      if (!seen) {
        shouldShow = true;
        try { localStorage.setItem(storageKey,'1'); } catch(e){}
      } else {
        shouldShow = isExternalEntrance || isReload || isBackForward;
      }
    } else {
      shouldShow = true;
    }
  }
  if (!shouldShow) { pre.classList.add('hide'); return; }

  const isLg = innerWidth >= 1024;
  const speedPct = Math.max(1, parseInt(pre.dataset.speed || '100', 10) || 100);
  const scale = (ms) => Math.round(ms * (100 / speedPct));

  const FADE_IN  = scale(parseInt(pre.dataset.fadeIn   || pre.dataset.fadeInMs   || '800', 10));
  const HOLD     = scale(parseInt(pre.dataset.fadeHold || pre.dataset.fadeHoldMs || '800', 10));
  const FADE_OUT = scale(parseInt(pre.dataset.fadeOut  || pre.dataset.fadeOutMs  || '800', 10));

  const LOGO_IN   = scale(1200);
  const T_LOGO    = 300;
  const T_RECT    = T_LOGO + LOGO_IN + 200;

  const RECT_DUR      = scale(1000);
  const REVEAL_DUR    = scale(750);
  const AFTER_COVER   = scale(100);
  const TEXT_IN_DELAY = scale(700);
  const EXIT_DWELL    = scale(2200);
  const IMG_EXIT_LAG  = scale(250);
  const WRAP_EXIT_LAG = scale(250);
  const HIDE_LAG      = scale(700);
  const TEXT_STAGGER  = scale(150);
  const SLIDE_DUR     = isLg ? scale(800) : scale(600);

  pre.style.setProperty('--logo-dur', LOGO_IN + 'ms');

  if (logo)    logo.classList.add('fade-target');
  if (imgWrap) imgWrap.classList.add('fade-target');

  const rectWrap = pre.querySelector('.preloader-rect-wrapper');
  if (rectWrap) rectWrap.style.display = (mode === 'cover') ? 'block' : 'none';

  const timers = [];
  const at = (t, fn) => timers.push(setTimeout(fn, t));
  const rAF = { grow: 0, clip: 0 };

  at(300, () => {
    if (mode === 'fade_sequence') {
      if (logo) { logo.style.setProperty('--fade-dur', FADE_IN + 'ms'); logo.classList.add('fade-in'); }
    } else {
      if (logo) logo.classList.add('logo-visible');
    }
  });

  if (mode === 'fade_sequence') {
    at(300 + FADE_IN + HOLD, () => {
      if (logo) { logo.classList.remove('fade-in'); logo.classList.add('fade-out'); }
    });

    const T_PHOTO_IN = 300 + FADE_IN + HOLD + FADE_OUT + 150;
    at(T_PHOTO_IN, () => {
      if (!imgWrap) return;
      imgWrap.style.display = 'block';
      imgWrap.style.visibility = 'visible';
      imgWrap.style.setProperty('--fade-dur', FADE_IN + 'ms');
      imgWrap.classList.add('fade-in');
      t1 && t1.classList.add('text-visible');
      setTimeout(() => { t2 && t2.classList.add('text-visible'); }, 300);
    });

    const T_PHOTO_OUT = T_PHOTO_IN + FADE_IN + HOLD;
    at(T_PHOTO_OUT, () => {
      if (imgWrap) { imgWrap.classList.remove('fade-in'); imgWrap.classList.add('fade-out'); }
      t1 && t1.classList.add('text-exit');
      setTimeout(() => { t2 && t2.classList.add('text-exit'); }, 150);
    });

    const T_EXIT = T_PHOTO_OUT + FADE_OUT;
    if (!debug) {
      at(T_EXIT, () => { pre.classList.add('slide-up'); pre.style.transitionDuration = SLIDE_DUR + 'ms'; });
      at(T_EXIT + HIDE_LAG, () => pre.classList.add('hide'));
    } else {
      const panel = document.getElementById('preloader-debug-panel');
      if (panel) {
        panel.style.display = 'flex';
        const modeState = document.getElementById('preloader-mode-state');
        const speedState = document.getElementById('preloader-speed-state');
        if (modeState) modeState.textContent = 'fade_sequence';
        if (speedState) speedState.textContent = String(speedPct);
      }
    }

  } else if (mode === 'image_only') {
    const T_IMAGE_ON = T_LOGO + LOGO_IN + 200;
    at(T_IMAGE_ON, () => {
      if (!imgWrap) return;
      imgWrap.style.display = 'block';
      imgWrap.style.opacity = '1';
      imgWrap.style.visibility = 'visible';
    });

    at(T_IMAGE_ON + TEXT_IN_DELAY, () => t1 && t1.classList.add('text-visible'));
    at(T_IMAGE_ON + TEXT_IN_DELAY + 300, () => t2 && t2.classList.add('text-visible'));

    if (!debug) {
      const EXIT_AT = T_IMAGE_ON + TEXT_IN_DELAY + EXIT_DWELL;
      at(EXIT_AT, () => {
        t1 && t1.classList.add('text-exit');
        setTimeout(() => { t2 && t2.classList.add('text-exit'); }, TEXT_STAGGER);
      });
      at(EXIT_AT + IMG_EXIT_LAG, () => imgEl && imgEl.classList.add('image-exit'));
      at(EXIT_AT + IMG_EXIT_LAG + WRAP_EXIT_LAG, () => {
        pre.classList.add('slide-up');
        pre.style.transitionDuration = SLIDE_DUR + 'ms';
      });
      at(EXIT_AT + IMG_EXIT_LAG + WRAP_EXIT_LAG + HIDE_LAG, () => pre.classList.add('hide'));
    } else {
      const panel = document.getElementById('preloader-debug-panel');
      if (panel) {
        panel.style.display = 'flex';
        const modeState = document.getElementById('preloader-mode-state');
        const speedState = document.getElementById('preloader-speed-state');
        if (modeState) modeState.textContent = 'image_only';
        if (speedState) speedState.textContent = String(speedPct);
      }
    }

  } else {
    at(T_RECT, () => {
      let prog = 0; let last = performance.now();
      const baseRate = 100 / RECT_DUR; const fastRate = baseRate * 3.2; const accelAt = 85;

      const loop = () => {
        const now = performance.now(); const dt = now - last; last = now;
        const rate = prog >= accelAt ? fastRate : baseRate;
        prog = Math.min(100, prog + rate * dt);
        if (rectEl) {
          const h = (isLg ? Number(pre.dataset.rectHLg||510) : Number(pre.dataset.rectHSm||333));
          rectEl.style.height = ((prog/100) * h) + 'px';
        }
        if (prog < 100) {
          rAF.grow = requestAnimationFrame(loop);
        } else {
          const h = (isLg ? Number(pre.dataset.rectHLg||510) : Number(pre.dataset.rectHSm||333));
          if (rectEl) rectEl.style.height = h + 'px';

          at(AFTER_COVER, () => {
            if (!imgWrap) return;
            imgWrap.style.display = 'block';
            imgWrap.style.opacity = '1';
            imgWrap.style.visibility = 'visible';
          });

          at(AFTER_COVER, () => {
            let clip = 0; const start = performance.now();
            const loopClip = () => {
              const p = Math.min(1, (performance.now() - start) / REVEAL_DUR);
              clip = Math.round(p * 100);
              if (rectEl) rectEl.style.clipPath = `inset(0 0 ${clip}% 0)`;
              if (p < 1) rAF.clip = requestAnimationFrame(loopClip);
            };
            rAF.clip = requestAnimationFrame(loopClip);
          });

          at(AFTER_COVER + TEXT_IN_DELAY, () => t1 && t1.classList.add('text-visible'));
          at(AFTER_COVER + TEXT_IN_DELAY + 300, () => t2 && t2.classList.add('text-visible'));

          if (!debug) {
            const EXIT_AT = AFTER_COVER + TEXT_IN_DELAY + EXIT_DWELL;
            at(EXIT_AT, () => {
              t1 && t1.classList.add('text-exit');
              setTimeout(() => { t2 && t2.classList.add('text-exit'); }, TEXT_STAGGER);
            });
            at(EXIT_AT + IMG_EXIT_LAG, () => imgEl && imgEl.classList.add('image-exit'));
            at(EXIT_AT + IMG_EXIT_LAG + WRAP_EXIT_LAG, () => {
              pre.classList.add('slide-up');
              pre.style.transitionDuration = SLIDE_DUR + 'ms';
            });
            at(EXIT_AT + IMG_EXIT_LAG + WRAP_EXIT_LAG + HIDE_LAG, () => pre.classList.add('hide'));
          } else {
            const panel = document.getElementById('preloader-debug-panel');
            if (panel) {
              panel.style.display = 'flex';
              const modeState = document.getElementById('preloader-mode-state');
              const speedState = document.getElementById('preloader-speed-state');
              if (modeState) modeState.textContent = 'cover';
              if (speedState) speedState.textContent = String(speedPct);
            }
          }
        }
      };
      rAF.grow = requestAnimationFrame(loop);
    });
  }

  const panel = document.getElementById('preloader-debug-panel');
  if (panel && debug) {
    panel.style.display = 'flex';
    const modeState = document.getElementById('preloader-mode-state');
    const speedState= document.getElementById('preloader-speed-state');
    if (modeState) modeState.textContent = mode;
    if (speedState) speedState.textContent = String(speedPct);
    const toggleBtn = document.getElementById('preloader-toggle-cover');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        const url = new URL(location.href);
        url.searchParams.set('mode', mode === 'cover' ? 'image_only' : 'cover');
        location.href = url.toString();
      });
    }
    addEventListener('keydown', (e) => {
      const k = e.key.toLowerCase();
      if (k === 'h') pre.classList.add('hide');
      if (k === 's') { pre.classList.add('slide-up'); pre.style.transitionDuration = SLIDE_DUR + 'ms'; }
      if (k === 'x') { try { localStorage.removeItem(storageKey); alert('Seen flag cleared'); } catch(e){} }
    });
  }

  addEventListener('pagehide', () => {
    if (!debug && frequency === 'once') {
      try { localStorage.setItem(storageKey, '1'); } catch(e){}
    }
  });
});